import commonMessages from '@rhg/lang/messages/common';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';

/**
 * Returns a formatter for a program's item count: "N Tracks" for music
 * programs (albums), "N Sessions" otherwise.
 */
export function useProgramItemCountText(meditationType?: string) {
    const { formatMessage } = useIntl();
    const isMusic = meditationType?.toLowerCase() === 'music';

    return useCallback(
        (count: number | undefined) =>
            isMusic
                ? formatMessage(commonMessages['common.tracks'], {
                      tracks: count,
                  })
                : formatMessage(commonMessages['common.sessions'], {
                      sessions: count,
                  }),
        [formatMessage, isMusic]
    );
}
